












import Vue from 'vue';
import { OpportunityItemStatus, OpportunityItemOtherStatus } from '@/models/opportunities';

export default Vue.extend({
  name: 'OpportunityStatus',
  props: {
    status: {
      default: OpportunityItemOtherStatus.Draft,
      type: String as () => ( OpportunityItemStatus | OpportunityItemOtherStatus ),
    },
  },
});
